import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProblemAgitate } from './components/ProblemAgitate';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { BuySection } from './components/BuySection';
import { FAQ } from './components/FAQ';
import { SalesPopup } from './components/SalesPopup';
export function App() {
  return <div className="min-h-screen bg-zinc-950 text-white selection:bg-lime-400 selection:text-zinc-950" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemAgitate data-id="element-4" />
        <Modules data-id="element-5" />
        <Testimonials data-id="element-6" />
        <Bonuses data-id="element-7" />
        <BuySection data-id="element-8" />
        <FAQ data-id="element-9" />
      </main>
      <SalesPopup data-id="element-10" />
    </div>;
}